import request from '@/utils/request'

// 支付订单
export function createOrderReq(query) {
  return request({
    url: '/api/order/createOrder',
    method: 'GET',
    params: query , //params修改为data
  })
}
//支付预订单 
export function presalePayOrderReq(query) {
  return request({
    url: '/api/order/presalePayOrder',
    method: 'POST',
    params: query , //params修改为data
  })
}

// 查询支付状态
export function payStatusReq(query) {
  return request({
    url: '/api/order/payStatus',
    method: 'GET',
    params: query , //params修改为data
  })
}

//验证订单状态
export function verifyKeyReq(query) {
  return request({
    url: '/api/order/verifyKey',
    method: 'GET',
    params: query , //params修改为data
  })
}


